import { View, ViewOff } from '@carbon/icons-react';
import { IconButton, InputStructure } from '@tablecheck/tablekit-react';
import * as React from 'react';

import { InputWithIcons, InputWrapper } from './styled';
import { PasswordFieldProps } from './types';

export function PasswordField({
  value,
  onChangeValue,
  validationFunc,
  name,
  label,
  onBlur,
  'data-variant': dataVariant,
  ...inputProps
}: PasswordFieldProps): JSX.Element {
  const [invalidKey, setInvalidKey] = React.useState<string>();
  const [shouldShowPassword, setShowPassword] = React.useState(false);
  const [isTouched, setTouched] = React.useState(false);
  const [val, setVal] = React.useState('');

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      const { value: newValue } = e.currentTarget;
      setVal(newValue);

      let invKey = '';
      if (validationFunc) {
        invKey = validationFunc(newValue) || '';
        setInvalidKey(invKey);
      }

      if (onChangeValue) onChangeValue(newValue, { invalidKey: invKey });
    },
    [onChangeValue, validationFunc]
  );

  return (
    <InputStructure
      name={name}
      label={label}
      input={
        <InputWrapper>
          <InputWithIcons
            data-stretch
            data-variant={isTouched && !!invalidKey ? 'error' : dataVariant}
          >
            <input
              {...inputProps}
              type={shouldShowPassword ? 'text' : 'password'}
              name={name}
              value={val}
              onChange={onChange}
              onBlur={(event) => {
                setTouched(true);
                if (onBlur) {
                  onBlur(event);
                }
              }}
            />
            <IconButton
              data-variant="bare"
              data-size="large"
              type="button"
              onClick={() => setShowPassword(!shouldShowPassword)}
            >
              {shouldShowPassword ? <View size={20} /> : <ViewOff size={20} />}
            </IconButton>
          </InputWithIcons>
        </InputWrapper>
      }
    />
  );
}
